import {com, plan, frame, ui, coding, animated, seo, performance, database, backend, testing, webhosting, support} from '../../../images/images';


const img = [
	com, plan, frame, ui, coding, animated, seo, performance, database, backend, testing, webhosting, support
];

export default img;